import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import { grey } from '@mui/material/colors';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { LenderConversionTableRowViewModel } from '@trnsact/trnsact-shared-types';
import { MUITable, MUITableSorting } from 'components/shared/MUITable';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { exportConversionTableToCsv, getConversionTableColumns, mapConversionTableRows } from '../../../../lib';
import { ConversionTableRow, ConversionTableSorting } from '../../../../types';

interface Props {
  rows: LenderConversionTableRowViewModel[];
  loading?: boolean;
  sorting: ConversionTableSorting;
  onSortingChange: (nextValue: ConversionTableSorting) => void;
}

export const LenderConversionTable = ({ rows, loading, sorting, onSortingChange }: Props) => {
  const tableData = mapConversionTableRows(rows);
  const columns = getConversionTableColumns();

  const tableSorting: MUITableSorting = {
    key: sorting.key,
    value: sorting.value,
    onChange: onSortingChange,
  };

  const handleExportCsv = useCallback(() => {
    exportConversionTableToCsv(tableData);
  }, [tableData]);

  return (
    <CardContainer
      title="Lender conversion table"
      actionBtn={
        <Button
          size="small"
          variant="outlined"
          data-pdf-exclude
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={handleExportCsv}
        >
          Export CSV
        </Button>
      }
    >
      <Box
        sx={{
          '& th, & td': { border: '1px solid', borderColor: 'divider' },
          '& th': { py: 1, px: 1.5, bgcolor: grey[300] },
        }}
      >
        <MUITable<ConversionTableRow>
          columns={columns}
          tableData={tableData}
          isLoading={!!loading}
          sorting={tableSorting}
        />
      </Box>
    </CardContainer>
  );
};
